import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {formatErrors} from "../../../constants";
import {clientUpdateAction} from "../../../actions/clientAction";
import {toast} from "react-toastify";
import {InputUserForm} from "../../../utils/input/InputUserForm";

export function ClientWeight({client, handleChange}) {
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setForm({
      man_height: client.man_height || '',
      weight: client.weight || '',
      weight_target: client.weight_target || '',
      weight_biggest: client.weight_biggest || ''
    });
  }, [client.man_height, client.weight, client.weight_target, client.weight_biggest]);

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value === '' ? '' : value * 1}
    });
  };

  const handleCancel = () => {
    if (edit === 'loading') {
      return;
    }
    setForm({
      man_height: client.man_height || '',
      weight: client.weight || '',
      weight_target: client.weight_target || '',
      weight_biggest: client.weight_biggest || ''
    });
    setEdit(false);
  };

  const handleSave = () => {
    if (edit === 'loading') {
      return;
    }
    setEdit('loading');
    const data = {...form};
    Object.keys(data).forEach((i) => {
      data[i] = data[i] === '' || isNaN(data[i]) ? 0 : data[i] * 1;
    });
    if (client.weight && form.weight !== client.weight) {
      data['weight_prev'] = client.weight;
    }
    dispatch(clientUpdateAction(client.id, data)).then(() => {
      setEdit(false);
      handleChange(data);
    }).catch(err => {
      setEdit(true);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <div className={"tabs__wrapper" + (edit ? " tabs__wrapper--edit" : "")}>
    {!edit && <React.Fragment>
      <span className="tabs__edit edit pointer" onClick={() => setEdit(true)}>Ред.</span>
      <div className="tabs__inner">
        <div className="tabs__heading">Рост</div>
        {client.man_height > 0 && <div className="tabs__value">{client.man_height} см</div>}
        {!client.man_height && <div className="tabs__value">&mdash;</div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Вес на данный момент</div>
        {client.weight > 0 && <div className={"tabs__value" + (client.weight_prev && client.weight < client.weight_prev ? " tabs__value--green" : "")}>{client.weight} кг {client.weight_prev ? "(" + (+(client.weight - client.weight_prev).toFixed(2)) + ")" : ""}</div>}
        {!client.weight && <div className="tabs__value">&mdash;</div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Целевой вес</div>
        {client.weight_target > 0 && <div className="tabs__value">{client.weight_target} кг</div>}
        {!client.weight_target && <div className="tabs__value">&mdash;</div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Самый большой вес</div>
        {client.weight_biggest > 0 && <div className="tabs__value">{client.weight_biggest} кг</div>}
        {!client.weight_biggest && <div className="tabs__value">&mdash;</div>}
      </div>
    </React.Fragment>}
    {edit && <React.Fragment>
      <div className="tabs__inner">
        <div className="tabs__heading">Рост</div>
        <div className="tabs__value">
          <InputUserForm type="number" value={form.man_height} name="man_height" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Вес на данный момент</div>
        <div className="tabs__value">
          <InputUserForm type="number" value={form.weight} name="weight" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Целевой вес</div>
        <div className="tabs__value">
          <InputUserForm type="number" value={form.weight_target} name="weight_target" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Самый большой вес</div>
        <div className="tabs__value">
          <InputUserForm type="number" value={form.weight_biggest} name="weight_biggest" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__buttons">
        <span className="tabs__btn tabs__btn--canceling btn pointer" onClick={handleCancel}>Отменить</span>
        <span className="tabs__btn tabs__btn--save btn pointer" onClick={handleSave}>Сохранить</span>
      </div>
    </React.Fragment>}
  </div>;
}
